// import err from '@/views/others/Error.vue'
const err = () =>
  import(/* webpackChunkName: "others" */ '@/views/others/Error.vue')
export default function (router) {
  router.push({
    path: '/error',
    name: 'error',
    component: err,
    beforeEnter: async (to, from, next) => {
      if (!to.query.hideSideMenu) {
        next({ name: 'error', query: { ...to.query, hideSideMenu: 1 } })
      }
      next()
    },
  })
}
